import Image from "next/image"
import ImageWithLoader from "../shared/imageWithLoader/ImageWithLoader"
import { IMediaCenterProps } from "./types"
import CustomButton from "../shared/CustomButton"
import { RefObject, useContext } from "react"
import { screenSizeContext } from "@/app/store/context/screenSizesContext"
import { usePopupContext } from "@/app/store/context/popupContext";

const LatestNewsCard = ({
	data,
	setModalData,
	sectionRef,
	insideAmenitiesDetailsPage,
	optimizedImage,
}: {
	data: IMediaCenterProps
	setModalData: any
	sectionRef?: RefObject<HTMLDivElement | null>
	insideAmenitiesDetailsPage?: boolean
	optimizedImage?: boolean
}) => {
  const { isIpad } = useContext(screenSizeContext)
  const formatDate = (dateString?: string) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      // day: "2-digit",
      month: "long",
      year: "numeric",
    });
  };

  const {
    setPopupInnerData
} = usePopupContext()

  const handleReadMore = () => {
    if (insideAmenitiesDetailsPage) {
      setPopupInnerData(data);
    } else {
      setModalData(data);
    }
    sectionRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="latestNews_card cursor-[-webkit-grab] ">
      {data?.card_image_desktop?.media_name &&
        data?.card_image_mobile?.media_name && (
          <div className="image_wrapper relative mb-5 h-[21.3rem] ">
            {optimizedImage ? (
              <ImageWithLoader
                src={
                  isIpad
                    ? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_mobile?.media_name
                    : process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_desktop?.media_name
                }
                alt={data.title?.en ?? "Media"}
                sizeVariant="twoCol"
                quality={75}
              />
            ) : (
              <Image
                src={
                  isIpad
                    ? process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_mobile?.media_name
                    : process.env.NEXT_PUBLIC_STATIC_MEDIA_API_URL +
                      data?.card_image_desktop?.media_name
                }
                alt={data.title?.en ?? "Media"}
                fill
              />
            )}
          </div>
        )}
      <div className={`content `}>
        <div className="date font-national text-labelM text-oWhite-60 mb-4">
          {formatDate(data.date)}
        </div>
        <div className="title font-minerva-regular text-bodyL text-oWhite-100 mb-2">
          {data.title?.en}
        </div>
        <div className="desc font-national text-bodyM text-oWhite-60 mb-4 w-[90%] ">
          {data?.card_description?.en}
        </div>
        <CustomButton
          text="Read more"
          hasIcon
          style="transparent"
          customClass="w-fit"
          action={handleReadMore}
        />
      </div>
    </div>
  )
}

export default LatestNewsCard
